import { account, error, tag } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FeeBasedTransferDestinationOptionsQuery = gql`
  query FeeBasedTransferDestinationOptions(
    $input: TransferOptionsInput
    $sourceAccountId: ID!
  ) {
    transferOptions(input: $input) {
      __typename
      ... on TransferOptions {
        destination {
          __typename
          ... on GroupedAccounts {
            internal {
              ...account
              transferSpeedTag(sourceAccountId: $sourceAccountId) {
                ...tag
              }
            }
            external {
              ...account
              transferSpeedTag(sourceAccountId: $sourceAccountId) {
                ...tag
              }
            }
          }
        }
        destinationExternalDebitCards {
          __typename
          id
          displayName
          institutionName
          lastFour
          isSelectable
          transferSpeedTag {
            ...tag
          }
        }
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${account}
  ${error}
  ${tag}
`;

export default FeeBasedTransferDestinationOptionsQuery;
